<template>
    <div>
        <div class="w" id="content">
            <div class="s_tl">
                当前位置：<a href="/">首页</a>
                <em class="lr3">&#62;</em>
                <a href="/help">帮助中心</a>
                <em class="lr3">&#62;</em>
                <a href="">新手上路</a>
                <em class="lr3">&#62;</em>
                <a href="">夜樱情趣商城优惠劵使用说明</a>
            </div>
            <div class="ubg">
                <left-side></left-side>
                <!--left over-->
                <div class="u_r">
                    <div class="ah1 alC yahei">
                        <h1 class="f18">夜樱情趣商城优惠劵使用说明</h1>
                        <p class="c9">发布时间：2022-01-04</p>
                    </div>
                    <div class="ainfo ov yahei" style="line-height: 32px;padding-top: 10px;font-size: 14px;">
                        <p><strong>一、优惠劵有什么作用</strong></p>
                        <p>为了答谢新老客户对夜樱情趣商城的支持，夜樱情趣商城会不定期的发放金额不等的优惠券；当订单金额条件达到时，可使用优惠券进行一定额度的减免，使用前请仔细查看优惠券的使用范围及条件；</p>
                        <p><br></p>
                        <p>
                            <strong>二、优惠券怎么使用</strong>
                        </p>
                        <p>当满足使用优惠券的条件时，可在订单结算时使用优惠券，具体使用方法如下：</p>
                        <p>（1）PC电脑端</p>
                        <p>
                            <img src="../../assets/image/common/tup2.png" width="900" height="500" alt=""><br>
                        </p>
                        <p>
                            <strong>三、如何获得优惠券</strong>
                        </p>
                        <p>1、参加夜樱情趣商城不定期举办的活动；</p>
                        <p><br></p>
                        <p>
                            <strong>四、如何查询优惠券</strong>
                        </p>
                        <p>登陆个人会员账户，在优惠券板块可查询优惠券相关情况；</p>
                        <p><br></p>
                        <p>
                            <strong>五、注意事项</strong>
                        </p>
                        <p>1、注册会员才可使用优惠券，非注册会员无法使用；</p>
                        <p>2、优惠券有一定的使用期限，请注意期限时间；</p>
                        <p>3、优惠券不可提现，不可赠送；</p>
                        <p>4、优惠券一切解释权归夜樱情趣商城所有；</p>
                        <p><br></p>
                    </div>
                    <!--info over-->
                    <p class="lh30"></p>
                    <p class="bline" style="padding: 30px 0px 0 0;"></p>
                    <p class="lh30"></p>
                    <p style="font-size:16px;">
                        <a href="/help/dingdan" style="float:left;">上一篇:如何查看/修改订单</a>
                        <a href="/help/fukuan" class="pl10" style="float:right">下一篇:订购方式与付款方式</a>
                    </p>
                </div>
                <!--right over-->
                <div class="clear"></div>
            </div>
        </div>
    </div>
</template>

<script>
import Left_side from "@/components/help/left-side"
export default {
    components:{
        'left-side': Left_side
    },
}
</script>

<style scoped>
.ubg{border:1px solid #e5e5e5;background-color:#fff;overflow:hidden;}
.u_l{width:170px;padding:10px;background:#fff;border-right:1px solid #e5e5e5;}
.u_r{padding:10px 40px 30px 40px;border-left:1px solid #e5e5e5;line-height:25px;background:#fff;margin-left:190px;min-height:600px;overflow: hidden;}
.dsl{display:inline;font-weight:normal;}
.udl{margin:0 5px 15px 5px;}
.udl dt{border-bottom:1px solid #e5e5e5;line-height:40px;display:block;font-size:14px;color:#333;font-weight:bold;margin-bottom:10px;}
.udl dd{line-height:30px;text-indent:15px;}
.udl a{display:block;color:#777;margin-bottom:1px;}
.udl a:hover,.udl a.on{color:#c40000;text-decoration:none; background-color:#e5e1e1;}
.article{width:100%;}
.article li{border-bottom:1px dashed #ddd;display:block;width:100%;font-size:14px;line-height:45px;}
.article a{display:block;width:100%;overflow:hidden;}
.article a:hover{color:#c40000;}
.ah1{color:#333;line-height:30px;padding-bottom:10px;border-bottom:2px solid #ddd;}
.a_goods a{width:220px;height:280px;display:inline;float:left;margin:10px 6px;line-height:18px;white-space:nowrap;overflow:hidden;}
</style>


// WEBPACK FOOTER //
// src/components/help/youuhijuan.vue